<template>
  <v-row row wrap>
    <v-col class="col-12">
      <v-slider
        v-model="opacity"
        :thumb-size="24"
        thumb-label="always"
        thumb-color="primary"
        track-color="grey lighten-2"
        track-fill-color="grey lighten-2"
        label="Opacity"
        max="100"
        min="0"
        @end="handleOnEnd"
        @mouseup="handleOnEnd"
        class="hyp-opacity"
        hide-details
      >
        <template v-slot:thumb-label="props">
          <span class="application-heading">{{ props.value }}%</span>
        </template>
      </v-slider>
    </v-col>
  </v-row>
</template>

<script>
import lodashGet from "lodash/get";
import lodashFind from "lodash/find";
import lodashDebounce from "lodash/debounce";

import { mapGetters } from "vuex";

import { SAVE_PREFERENCES } from "@/store/actions.type";
import {
  MODULE_PREFIX_PULSE,
  MODULE_PREFIX_USER,
  MODULE_PREFIX_MAP,
} from "@/store";
import {
  buildPreferences,
  getOpacityFromPreferences,
} from "@/services/grids/stability.service";
import { MAIN_MAP_ID, DEFAULT_OPACITY_PULSE } from "@/common/constants/maps";
import { EVENT_CATEGORIES, EVENT_ACTIONS } from "@/common/constants/analytics";

export default {
  name: "PulseOpacityBar",
  data: () => ({
    opacity: DEFAULT_OPACITY_PULSE * 100,
  }),
  mounted() {
    this.getPrefs();
  },
  computed: {
    ...mapGetters({
      preferences: MODULE_PREFIX_USER + "preferences",
      pulseParams: MODULE_PREFIX_PULSE + "params",
      maps: MODULE_PREFIX_MAP + "maps",
    }),
    map() {
      return this.maps[MAIN_MAP_ID];
    },
  },
  methods: {
    handleOnEnd() {
      let params = this.pulseParams;
      lodashDebounce(() => {
        const mapLayers = this.map.getStyle().layers;
        let pulseLayer = lodashFind(mapLayers, [
          "source-layer",
          "PulseCountryStability",
        ]);
        if (!pulseLayer) {
          pulseLayer = lodashFind(mapLayers, [
            "source-layer",
            "PulseCountyStability",
          ]);
        }
        if (!pulseLayer) {
          pulseLayer = lodashFind(mapLayers, [
            "source-layer",
            "PulseCityStability",
          ]);
        }
        if (!pulseLayer) {
          pulseLayer = lodashFind(mapLayers, [
            "source-layer",
            "PulseRegionStability",
          ]);
        }

        if (lodashGet(pulseLayer, "id")) {
          this.map.setPaintProperty(
            pulseLayer.id,
            "fill-opacity",
            parseInt(this.opacity) / 100
          );
          this.map.setPaintProperty(
            pulseLayer.id,
            "fill-outline-color",
            "#4b4b4b"
          );
        }

        this.handlePageTrackerEvent(
          EVENT_CATEGORIES.pulse_opacity,
          EVENT_ACTIONS.changed,
          this.opacity
        );

        params = buildPreferences({
          preferences: this.preferences,
          opacity: this.opacity,
        });

        this.$store.dispatch(MODULE_PREFIX_USER + SAVE_PREFERENCES, params);
      }, 800)();
    },
    getPrefs() {
      this.opacity = getOpacityFromPreferences(this.preferences);
    },
  },
  watch: {
    pulseParams: {
      handler() {
        this.getPrefs();
      },
      deep: true,
    },
  },
};
</script>

<style>
.hyp-opacity .v-label {
  font-size: 12px;
}
.hyp-opacity .v-slider__thumb-label {
  width: 34px !important;
  border-radius: 9px !important;
  font-size: 0.65rem !important;
  -webkit-transform: translateY(-20%) translateY(-6px) translateX(-50%) !important;
  transform: translateY(-20%) translateY(-6px) translateX(-50%) !important;
}
.hyp-opacity .v-slider--horizontal .v-slider__thumb-label > * {
  -webkit-transform: none !important;
  transform: none !important;
}
.v-input--selection-controls .v-input__slot > .v-label {
  flex: unset !important;
}
</style>
<style scoped></style>
